import styled from "styled-components";

const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 16px;
`;

export default MenuButton;
